import gameiomModel from "gameiom/model/gameiom-model";
import BetModel from "slotworks/model/bets/bet-model";
import Gameplay from "slotworks/model/gameplay/gameplay";
import SpinRequestPayload from "slotworks/model/gameplay/requests/spin-request-payload";
import { RequestBuilder } from "slotworks/server/builders/request-builder";
import { SocketRequest } from "slotworks/server/connectors/socket-connector";

export class SpinRequestBuilder implements RequestBuilder {

    public static force: string;

    public filter(request: any): boolean {
        return request instanceof SpinRequestPayload;
    }

    public build(gameplay: Gameplay, request: any) {

        let clearRecovery: boolean = false;
        let force: string | number[] = SpinRequestBuilder.force;

        if (force && typeof force === "string") {
            if (force.indexOf(",") > -1) {
                force = force.split(",").map((v) => parseInt(v));
            } else if (force.indexOf(" ") > -1) {
                force = force.split(" ").map((v) => parseInt(v));
            }
        }

        if (force === "clearRecovery") {
            clearRecovery = true;
            force = null;
        }

        SpinRequestBuilder.force = null;

        const body = {
            publicState: {
                action: "spin",
                gameId: gameiomModel.gameId,
                betAmount: BetModel.getCreditPerLine(),
                denom: BetModel.getCreditSize(),
                force
            }
        };

        if (body.publicState.force === null) {
            delete body.publicState.force;
        }

        if (clearRecovery) {
            ((body.publicState) as any).cleanState = true;
        }

        return new SocketRequest(body, gameiomModel.url);
    }
}

export default new SpinRequestBuilder();
